import { pathnameToRoutePattern } from './pathnameToRoutePattern';

export const NR_ROUTE_VIEW_ACTION = 'routeView';

type NewRelicRouteSyncAgent = {
  setCurrentRouteName?: (routeName: string) => void;
  setCustomAttribute?: (name: string, value: string, persist?: boolean) => void;
  addPageAction?: (name: string, attributes?: Record<string, string>) => void;
  interaction?: () => {
    setName?: (name: string) => { save?: () => void };
  };
};

/**
 * Keeps SPA route context on BrowserInteraction (setCurrentRouteName), PageAction
 * (routeView — reliable for NRQL dashboards), and JavaScriptError (persisted route).
 */
export function syncNewRelicRouteContext(
  nr: NewRelicRouteSyncAgent,
  pathname: string,
  routePatterns: string[],
  platformSurface: string
): string {
  const routePattern = pathnameToRoutePattern(pathname, routePatterns);

  nr.setCurrentRouteName?.(routePattern);
  nr.setCustomAttribute?.('route', routePattern, true);
  nr.setCustomAttribute?.('platform.surface', platformSurface, true);
  nr.addPageAction?.(NR_ROUTE_VIEW_ACTION, { route: routePattern });

  try {
    const ixn = nr.interaction?.();
    ixn?.setName?.(routePattern)?.save?.();
  } catch {
    // interaction() may be unavailable outside an active soft navigation
  }

  return routePattern;
}
